import React from 'react';
import classnames from 'classnames';
import localStorage from 'local-storage';
import { friendlyErrorMessage } from 'app/utils/parsers';
import Alert from 'app/components/general/Alert';
import Button from 'app/components/general/Button';
import {
  Input, Card, CardBody, FormGroup, Form,
  Label,
  InputGroup,
  FormFeedback,
} from 'reactstrap';
import _ from 'lodash';

import StepNumberDivider from 'app/components/general/StepNumberDivider';

interface IVerifyEmailProps {
  email: string;
  verifyUser: any;
  isLoading: boolean;
  hasSaved: boolean;
  hasFailed: boolean;
  backendErrors: any;
  location: any;
}
interface IVerifyEmailState {
  pin: any;
  backendErrors: any;
  errors: any;
  changed: boolean;
}
export default class VerifyEmail extends React.Component<
IVerifyEmailProps,
IVerifyEmailState
> {
  static defaultProps: IVerifyEmailProps = {
    email: undefined,
    isLoading: false,
    hasSaved: false,
    hasFailed: false,
    verifyUser: undefined,
    location: undefined,
    backendErrors: undefined,
  };

  state: IVerifyEmailState = {
    pin: null,
    backendErrors: this.props.backendErrors || {},
    errors: {},

    changed: false,
  };

  static getDerivedStateFromProps(nextProps, prevState): any {
    if (!prevState.changed && nextProps.backendErrors !== prevState.backendErrors) {
      return { ...prevState, backendErrors: nextProps.backendErrors, errors: nextProps.backendErrors };
    }
    return null;
  }

  handleSubmit = (e): void => {
    e.preventDefault();
    const email = this.email();
    this.setState({ changed: false }, () => {
      this.props.verifyUser({
        email,
        value: this.state.pin,
      });
    });
  };

  handleChange = (e) => {
    e.persist();
    this.setState((previousState) => ({
      ...previousState,
      changed: true,
      pin: e.target.value,
      backendErrors: {},
    }));
  };

  pinValid = (): boolean => !_.isEmpty(this.state.pin) && this.state.pin.length === 6;

  email = (): string => {
    if (!_.isEmpty(this.props.email)) {
      return this.props.email;
    } if (!_.isEmpty(this.props?.location?.data?.email)) {
      return this.props?.location?.data?.email;
    }
    return localStorage.get('onboarding')?.email;
  }

  renderBackendErrors(): React.ReactNode {
    if (
      !_.isEmpty(this.state.backendErrors?.message)
    ) {
      return (
        <Alert color="error">
          {friendlyErrorMessage(this.state.backendErrors.message)}
        </Alert>
      );
    }
    return null;
  }

  render(): React.ReactNode {
    const email = this.email();
    return (
      <div>
        <div className="row">
          <div className="col">
            <Card className="extra-shadow">
              <CardBody className="with-extra-padding-2">
                <Form onSubmit={this.handleSubmit}>
                  <div className="row">
                    <div className="col">
                      <h2>
                        Almost there!
                        <br />
                        Please check your email.
                      </h2>
                    </div>
                  </div>
                  <div className="row with-margin-top-10">
                    <div className="col">
                      <StepNumberDivider number={3} total={4} />
                    </div>
                  </div>
                  <div className="row with-margin-top-10">
                    <div className="col">
                      <span className="text-black">
                        Enter the 6 digit code sent to
                        {' '}
                        {email}
                        &nbsp;to ensure your account is secure.
                      </span>
                    </div>
                  </div>
                  <div className="row with-margin-top-10">
                    <div className="col">
                      <FormGroup>
                        <Label className="form-control-label" for="pin">
                          6 digit pin code
                        </Label>
                        <InputGroup className={classnames('large', { 'is-invalid': this.state.errors.pin })}>
                          <Input
                            onChange={this.handleChange}
                            type="tel"
                            name="pin"
                            className="large big-input"
                            value={this.state.pin}
                            placeholder="6 digit pin code"
                            aria-label="6 digit pin code"
                          />
                        </InputGroup>
                        <FormFeedback>{!_.isEmpty(this.state.errors.pin) && (this.state.errors.pin)}</FormFeedback>
                      </FormGroup>
                    </div>
                  </div>
                  <div className={classnames('row text-left normal-text', {
                    'row d-none': this.pinValid(),
                  })}
                  >
                    <div className="col">
                      <a
                        href="https://help.teammo.com.au/en/articles/4666426-i-have-not-received-a-verification-code"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        I didn&#39;t receive a verification code
                      </a>
                    </div>
                  </div>
                  <div
                    className={classnames('row d-none', {
                      'd-flex': this.pinValid(),
                    })}
                  >
                    <div className="col">
                      <Button
                        className="btn-1 btn-full-width success-sm large"
                        color="primary"
                        tabIndex="6"
                        loadingText="Verifying"
                        isLoading={this.props.isLoading}
                        hasSaved={this.props.hasSaved}
                        hasFailed={this.props.hasFailed}
                        disabled={!this.pinValid()}
                        type="submit"
                      >
                        Verify
                      </Button>
                    </div>
                  </div>
                  <div className="row with-margin-top-10">
                    <div className="col">
                      {this.renderBackendErrors()}
                    </div>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    );
  }
}
